import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from "@/helpers/authservice/jwt.service";
const timeout = 800000
/**
  * Service to call HTTP request via Axios
 */
class BaseService {

  constructor(baseURL, apiKey, header_auth = 'Authorization') {
    this.baseURL = baseURL
    this.apiKey = apiKey
    this.header_auth = header_auth
  }

  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = this.baseURL
  }

  /**
   * Send the GET HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  async get(resource, params = {}, responseType = undefined) {
    this.init()
    let headers = {
      [this.header_auth]: this.header_auth == 'Authorization' ? `Bearer ${JwtService.getToken()}` : `${this.apiKey}`,

    }

    if (this.header_auth !== 'Authorization') {
      headers['Authorization'] = `Bearer ${JwtService.getToken()}`
    }

    return await Vue.axios.get(`${resource}`, {
      params,
      timeout: timeout,
      responseType: responseType,
      headers
    })
  }

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  async post(resource, params) {
    this.init()
    let headers = {
      [this.header_auth]: this.header_auth == 'Authorization' ? `Bearer ${JwtService.getToken()}` : `${this.apiKey}`,
    }

    if (this.header_auth !== 'Authorization') {
      headers['Authorization'] = `Bearer ${JwtService.getToken()}`
    }

    return await Vue.axios.post(`${resource}`, params, {
      timeout: timeout,
      headers
    })
  }

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  async put(resource, params) {
    this.init()
    let headers = {
      [this.header_auth]: this.header_auth == 'Authorization' ? `Bearer ${JwtService.getToken()}` : `${this.apiKey}`,
    }

    if (this.header_auth !== 'Authorization') {
      headers['Authorization'] = `Bearer ${JwtService.getToken()}`
    }
    return Vue.axios.put(`${resource}`, params, {
      timeout: timeout,
      headers
    })
  }

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  async delete(resource, payload = {}) {
    this.init()
    let headers = {
      [this.header_auth]: this.header_auth == 'Authorization' ? `Bearer ${JwtService.getToken()}` : `${this.apiKey}`,
    }

    if (this.header_auth !== 'Authorization') {
      headers['Authorization'] = `Bearer ${JwtService.getToken()}`
    }
    return await Vue.axios.delete(resource, {
      data: payload,
      timeout: timeout,
      headers
    })
  }
}

export default BaseService
